import { IGif } from '@giphy/js-types'
import { Gif } from '@giphy/react-components'
import Privacy from 'mobile/shared/privacy'
import React, { FC, useState } from 'react'
import Carousel from 'shared/components/gif-carousel'
import useWindowSize from 'shared/hooks/window-size'
import styled from 'styled-components'
import Primary from './primary/primary'

const Media = styled.div`
    margin-bottom: 10px;
    overflow: hidden;
    position: relative;

    img {
        -webkit-touch-callout: default;
    }
`

const Sticker = styled(Media)`
    background-color: transparent;
    background-image: url('/static/img/backgrounds/bg-tile-dark.png');

    img {
        background-color: inherit;
    }
`

const SingleGif = styled.div`
    > div {
        margin: 0 auto;
    }
`

type Props = {
    gif: IGif
    nextGif?: IGif
    previousGif?: IGif
    singleGif?: boolean
    maxHeight?: number
    isPrivate?: boolean
    onSwipe?: (gif: IGif, isPrevious?: boolean) => void
    onDoubleTap?: () => void
    children: React.ReactNode
}

const GifHidden = ({ is_hidden }) => (is_hidden ? <Privacy /> : null)

const GifDetailGif: FC<Props> = ({
    children,
    gif,
    nextGif,
    previousGif,
    singleGif,
    isPrivate,
    onSwipe,
    onDoubleTap,
    maxHeight,
}) => {
    const { innerHeight, innerWidth } = useWindowSize()
    const [swipeProgress, setSwipeProgress] = useState(0)
    const { is_sticker: isSticker, is_hidden } = gif
    const peekGif = Math.abs(swipeProgress) ? (swipeProgress < 0 ? nextGif : previousGif) : null
    const WrapperComponent = isSticker ? Sticker : Media
    const aspectRatio = gif.images.original.width / gif.images.original.height
    const singleGifHeight = Math.min(innerWidth / aspectRatio, maxHeight || 99999)
    return (
        <>
            <WrapperComponent>
                {singleGif ? (
                    <>
                        <SingleGif>
                            <Gif
                                gif={gif}
                                width={singleGifHeight * aspectRatio}
                                height={singleGifHeight}
                                noLink
                                hideAttribution
                            />
                        </SingleGif>
                        {children}
                    </>
                ) : (
                    <Carousel
                        currentGif={gif}
                        previousGif={previousGif}
                        nextGif={nextGif}
                        width={innerWidth}
                        height={innerHeight - 150} // fill screen with room for header + attribution
                        onProgress={setSwipeProgress}
                        onComplete={onSwipe}
                        onDoubleTap={onDoubleTap}
                    >
                        {children}
                    </Carousel>
                )}
            </WrapperComponent>
            {!isPrivate && (
                <>
                    <GifHidden is_hidden={is_hidden} />
                    <Primary gif={gif} nextGif={peekGif} swipeProgress={swipeProgress} />
                </>
            )}
        </>
    )
}

export default GifDetailGif
